import React, { useState } from 'react'
import DashboardLayout from '../../components/layouts/dashboard'
import TabView from '../../components/tabview'
import { useGetAnnouncementsCount } from '../../redux/employee/hook/announcement'
import AllAnnouncements from '../../components/announcements/all-announcements'
import UnreadAnnouncements from '../../components/announcements/unread-announcements'

const AnnouncementsPage = () => {
  const [activeTab, setActiveTab] = useState(1)

  const { data: announcementCount } = useGetAnnouncementsCount()
  const AnnouncementTabs = [
    {
      title: (
        <>
          <div className='flex items-center gap-1'>
            <h1 className='text-sm font-medium'>All Announcements</h1>
            <span className='text-white text-xs bg-error h-5 w-5 flex items-center justify-center p-2 rounded-full'>
              {announcementCount?.total_count ?? 0}
            </span>
          </div>
        </>
      ),
      Content: AllAnnouncements,
    },
    {
      title: (
        <div className='flex items-center gap-1'>
          <h1 className='text-sm font-medium'>Unread Announcements</h1>

          <span className='text-white text-xs bg-error h-5 w-5 flex items-center justify-center p-2 rounded-full'>
            {announcementCount?.unread_count ?? 0}
          </span>
        </div>
      ),
      Content: UnreadAnnouncements,
    },
  ]
  return (
    <DashboardLayout title='Announcements'>
      <div className='font-bold text-lg mb-3 text-hr-primary-1'>
        Announcements
      </div>
      <div className='mt-2'>
        <TabView
          Tabs={AnnouncementTabs}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </div>
    </DashboardLayout>
  )
}

export default AnnouncementsPage
